import React from "react";

function Dessert() {
  return (
    <div class="wrapper" id="menu">
      <div class="title">
        <h4 style={{ textAlign: "center" }}>
          <span>voici nos Dessert N'hésitez pas appelez le 09 50 85 13 53</span>
          Desserts{" "}
        </h4>
      </div>
      <div class="menu">
        <div class="single-menu">
          <img
            src="http://troyesstar.fr/wp-content/uploads/2018/05/dessert3.png"
            alt=""
          />
          <div class="menu-content">
            <h4>
              {" "}
              Tarte au Daim <span>2.5€</span>
            </h4>
          </div>
        </div>
        <div class="single-menu">
          <img
            src="https://chezlbabar.files.wordpress.com/2014/03/tiramisu.jpg"
            alt=""
          />
          <div class="menu-content">
            <h4>
              Tiramisu <span>2.5€</span>
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dessert;
